import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Row, Col, Typography, Spin } from 'antd';
import LayoutContainer from '@/containers/LayoutContainer';
import Breadcrumb from '@/components/Breadcumb';
import JobTypeForm from '@/forms/JobTypeForm';

import { createJobType } from '@/actions/jobTypeActions';
import { fetchDepartments } from '@/actions/departmentActions';
import { getDepartments } from '@/selectors/departmentSelectors';
import { createRequestLoadingSelector } from '@/selectors/requestSelectors';
import { getErrors } from '@/selectors/errorSelectors';
import './index.scss';

const { Title } = Typography;

class JobTypeCreateContainer extends Component {
  componentDidMount() {
    const { dispatchFetchDepartments } = this.props;
    dispatchFetchDepartments();
  }

  handleSubmit = (values) => {
    const { dispatchCreateJobType } = this.props;
    dispatchCreateJobType(values);
  }

  handleCancel = () => {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const {
      errors,
      loading,
      submitting,
      selectableDepartments,
    } = this.props;

    return (
      <LayoutContainer contentClassName={['content-container', 'jobtype-create-container']}>
        <Row>
          <Col xs={24} xl={16}>
            <Title level={2} className="content-container__title">
              Create New Job Type
            </Title>
            <Breadcrumb
              items={[
                { key: 'home', link: '/', title: 'Home' },
                { key: 'job-types', link: '/job-types', title: 'Job Types' },
                { key: 'create', title: 'Create New Job Type' },
              ]}
              className="content-container__breadcrumb"
            />
            {loading ? (
              <Spin />
            ) : (
              <JobTypeForm
                submitting={submitting}
                submitTitle='Create Job Type'
                onSubmit={this.handleSubmit}
                onCancel={this.handleCancel}
                formObject={{
                  id: null,
                  departmentIds: [],
                  name: '',
                }}
                formErrors={errors}
                departmentSelectOptions={selectableDepartments}
              />
            )}
          </Col>
        </Row>
      </LayoutContainer>
    );
  }
}

JobTypeCreateContainer.propTypes = {
  history: PropTypes.object,
  loading: PropTypes.bool,
  submitting: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  selectableDepartments: PropTypes.arrayOf(PropTypes.object),
  dispatchFetchDepartments: PropTypes.func,
  dispatchCreateJobType: PropTypes.func,
};

const loadingInputData = createRequestLoadingSelector(['fetchDepartments']);
const submittingJobType = createRequestLoadingSelector(['createJobType']);

const mapStateToProps = (state) => ({
  errors: getErrors(state),
  loading: loadingInputData(state),
  submitting: submittingJobType(state),
  selectableDepartments: getDepartments(state),
});

export default withRouter(
  connect(mapStateToProps, {
    dispatchCreateJobType: createJobType,
    dispatchFetchDepartments: fetchDepartments,
  })(JobTypeCreateContainer),
);
